module.exports = __webpack_public_path__ + "img/sami.245af978.png";